export default __webpack_public_path__ + "static/media/menu-02-campaign-b.ee9a614d.svg";